export const initState = {
	from: 0,
	to: 10,
	$list: [],
	_list: 'init',
};

export default initState;
